import React, { useState, useEffect } from "react";
import "./sidebar.css";
import axios from "../../axios";
import {
  ChevronRight,
  ChevronDown,
  LayoutDashboard,
  Presentation,
  Library,
  FileQuestion,
  ClipboardList,
  ClipboardCheck,
  MessagesSquare,
  ChartSpline,
  FilePlus,
  UserCheck,
  GraduationCap,
  Wallet,
  Users,
  BookOpen,
  BookMarked,
  Activity,
  UsersRound,
  MessageCircleQuestion,
  TrendingUp,
  FileBarChart,
  Award,
  FileText,
  CalendarCheck,
  CalendarClock,
  BellRing,
  Send,
  ListChecks,
  Scale,
  Pencil,
  MonitorPlay,
} from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { setRouteLoading } from "../../redux/initialDataSlice";
import { useDispatch, useSelector } from "react-redux";
import ActiveMenuEnum from "../../Enum/ActiveMenuEnum";
import { setActiveMenu, setIsMenuExpended } from "../../redux/PageSlice";
import assets from "../../assets/assets";
import { hasFeature } from "../../Utils/features";
import {
  Box,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
  Divider,
  IconButton,
} from "@mui/material";

const Header = localStorage.getItem("Header");

// Utility: Converts any string to "First Letter Uppercase, Rest Lowercase" per word
const toTitleCase = (str) => {
  if (!str) return "";
  return String(str)
    .toLowerCase()
    .split(" ")
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
    .join(" ");
};

// Light theme palette
const COLORS = {
  bg: "#ffffff",
  bgHover: "#f4f6fa",
  bgActive: "#fff4e5",
  border: "#e6e9ef",
  textPrimary: "#1f2733",
  textSecondary: "#5b6472",
  textMuted: "#8a93a3",
  accent: "#f77f00",
  accentSoft: "rgba(247, 127, 0, 0.10)",
  accentSoftHover: "rgba(247, 127, 0, 0.18)",
};

function Sidebar({ setLeftSidebarSize }) {
  const [open, setOpen] = useState(false);
  const [openOnHover, setOpenOnHover] = useState(false);
  const [subItem, setSubItem] = useState(false);
  const [hwSubMenue, sethwSubMenue] = useState(false);
  const [studAttenSubMenue, setStudAttenSubMenue] = useState(false);
  const [isExpand, setIsExpand] = useState(true);
  const [active, setActive] = useState(false);
  const [active1, setActive1] = useState(false);
  const [HWMactive, setHWMActive] = useState(false);
  const [engage, setEngage] = useState(false);
  const [studAttendance, setStudAttendance] = useState(false);
  const [studPerformance, setStudPerformance] = useState(false);
  const [studPerformanceSubMenue, setStudPerformanceSubMenue] = useState(false);
  const [teaHr, setTeaHr] = useState(false);
  const [teaHrSubMenue, setTeaHrSubMenue] = useState(false);
  const [offlineMarksSubMenu, setOfflineMarksSubMenu] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const activeMenu = useSelector((stage) => stage.pageSlice.activeMenu);
  const isMenuExpended = useSelector((stage) => stage.pageSlice.isMenuExpended);

  useEffect(() => {
    if (hwSubMenue) {
      setHWMActive(true);
      setEngage(false);
    } else {
      setHWMActive(false);
      sethwSubMenue(false);
      setActive(false);
    }
  }, [activeMenu]);

  useEffect(() => {
    if (
      window.location.pathname === "/queryGroups" ||
      window.location.pathname === "/TotalCommuPost"
    ) {
      setEngage(true);
    } else {
      setHWMActive(false);
      setEngage(false);
    }
  }, []);

  useEffect(() => {
    const p = location.pathname;
    if (
      hasFeature("TEACH_ATT") &&
      (p.startsWith("/tea-attendance") || p.startsWith("/tea-leave"))
    ) {
      setTeaHr(true);
      setTeaHrSubMenue(true);
    }
  }, [location.pathname]);

  const handleOfflineMarks = () => {
    setOfflineMarksSubMenu((prev) => !prev);
  };

  const toggle = () => {
    setOpen(!isMenuExpended);
    dispatch(setIsMenuExpended(!isMenuExpended));
    if (isExpand) {
      setLeftSidebarSize(270);
      setIsExpand(!isExpand);
    } else if (!isExpand) {
      setLeftSidebarSize(70);
      setIsExpand(!isExpand);
    }
  };

  const handelExpendBtn = () => {
    if (subItem) {
      setSubItem(false);
      setActive(false);
      sethwSubMenue(false);
      setEngage(false);
      setStudAttenSubMenue(false);
      setStudAttendance(false);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    } else {
      setSubItem(true);
      setActive(false);
      setActive1(true);
      setEngage(true);
      sethwSubMenue(false);
      setStudAttenSubMenue(false);
      setStudAttendance(false);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    }
  };

  const handelExpendBtnStudAttendance = () => {
    if (studAttenSubMenue) {
      setSubItem(false);
      setActive(false);
      sethwSubMenue(false);
      setEngage(false);
      setStudAttendance(true);
      setStudAttenSubMenue(false);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setStudAttendance(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    } else {
      setSubItem(false);
      setActive(false);
      setActive1(true);
      setEngage(false);
      sethwSubMenue(false);
      setStudAttendance(true);
      setStudAttenSubMenue(true);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    }
  };

  const handelExpendBtnPerformance = () => {
    if (studPerformanceSubMenue) {
      setSubItem(false);
      setActive(false);
      sethwSubMenue(false);
      setEngage(false);
      setStudAttendance(false);
      setStudAttenSubMenue(false);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setOfflineMarksSubMenu(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    } else {
      setSubItem(false);
      setActive(false);
      setActive1(true);
      setEngage(false);
      sethwSubMenue(false);
      setStudAttendance(false);
      setStudAttenSubMenue(false);
      setStudPerformance(true);
      setStudPerformanceSubMenue(true);
      setOfflineMarksSubMenu(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    }
  };

  const handelExpendTeaHr = () => {
    if (teaHrSubMenue) {
      setSubItem(false);
      setActive(false);
      sethwSubMenue(false);
      setEngage(false);
      setStudAttenSubMenue(false);
      setStudAttendance(false);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    } else {
      setSubItem(false);
      setActive(false);
      setActive1(true);
      setEngage(false);
      sethwSubMenue(false);
      setStudAttenSubMenue(false);
      setStudAttendance(false);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setTeaHr(true);
      setTeaHrSubMenue(true);
    }
  };

  const handelExpendHW = () => {
    if (hwSubMenue) {
      setSubItem(false);
      sethwSubMenue(false);
      setActive(false);
      setEngage(false);
      setStudAttenSubMenue(false);
      setStudAttendance(false);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    } else {
      setSubItem(false);
      sethwSubMenue(true);
      setActive1(true);
      setEngage(false);
      setActive(true);
      setStudPerformance(false);
      setStudPerformanceSubMenue(false);
      setStudAttenSubMenue(false);
      setStudAttendance(false);
      setTeaHr(false);
      setTeaHrSubMenue(false);
    }
  };

  const handleHomeWorkClick = () => {
    localStorage.setItem("myData", "");
    localStorage.setItem("myData1", "");
    localStorage.removeItem("selectedDate");
    localStorage.removeItem("selectedCheckboxes");
    localStorage.removeItem("selectedDay");
    localStorage.setItem("buttons", "Published");
    navigate("/PublishedHomework");
  };

  const hasHomework =
    hasFeature("AS_HW") || hasFeature("AS_PR") || hasFeature("AS_ACT");

  const hasAssessment =
    hasFeature("ADAPT_ASS") || hasFeature("AUTO_ASS") || hasFeature("TCHR_ASS");

  const hasEngagement = hasFeature("COMMUNITY") || hasFeature("DOUBT_SOLV");

  const hasPerformance = hasFeature("OL_PERF") || hasFeature("OFFL_PERF");

  const hasHW = hasFeature("AS_HW");
  const hasPR = hasFeature("AS_PR");
  const hasACT = hasFeature("AS_ACT");

  // ---------- Reusable helpers ----------
  const expanded = isMenuExpended || openOnHover;

  const menuBtnSx = (isActive) => ({
    borderRadius: "10px",
    mb: 0.5,
    px: 1.25,
    py: 0.85,
    minHeight: 44,
    justifyContent: expanded ? "flex-start" : "center",
    transition: "all 0.2s ease",
    background: isActive ? COLORS.bgActive : "transparent",
    borderLeft: isActive
      ? `3px solid ${COLORS.accent}`
      : "3px solid transparent",
    "&:hover": {
      background: isActive ? COLORS.accentSoftHover : COLORS.bgHover,
    },
  });

  const iconBoxSx = {
    minWidth: 0,
    mr: expanded ? 1.25 : 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const textSx = (isActive) => ({
    fontSize: "0.875rem",
    fontWeight: isActive ? 700 : 500,
    color: isActive ? COLORS.accent : COLORS.textPrimary,
    letterSpacing: "0.2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  });

  const subItemSx = (isActive) => ({
    borderRadius: "8px",
    pl: 2,
    pr: 1.5,
    py: 0.55,
    minHeight: 34,
    color: isActive ? COLORS.accent : COLORS.textSecondary,
    fontSize: "0.8rem",
    fontWeight: isActive ? 600 : 400,
    textTransform: "none",
    "&:hover": {
      background: COLORS.bgHover,
      color: COLORS.accent,
    },
  });

  const renderIcon = (Icon, isActive, size = 20) => (
    <Icon
      size={size}
      strokeWidth={2}
      color={isActive ? COLORS.accent : COLORS.textSecondary}
    />
  );

  const renderMenuItem = ({
    label,
    Icon,
    isActive,
    onClick,
    showArrow,
    arrowExpanded,
  }) => (
    <Tooltip
      title={!expanded ? toTitleCase(label) : ""}
      placement="right"
      arrow
      disableHoverListener={expanded}
    >
      <ListItemButton sx={menuBtnSx(isActive)} onClick={onClick} disableRipple>
        <ListItemIcon sx={iconBoxSx}>{renderIcon(Icon, isActive)}</ListItemIcon>
        {expanded && (
          <>
            <ListItemText
              primary={toTitleCase(label)}
              primaryTypographyProps={{ sx: textSx(isActive) }}
              sx={{ my: 0 }}
            />
            {showArrow && (
              <ChevronDown
                size={16}
                color={isActive ? COLORS.accent : COLORS.textMuted}
                style={{
                  transition: "transform 0.25s ease",
                  transform: arrowExpanded ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            )}
          </>
        )}
      </ListItemButton>
    </Tooltip>
  );

  const renderSubItem = ({ label, Icon, isActive, to, onClick }) => (
    <NavLink to={to} style={{ textDecoration: "none" }} onClick={onClick}>
      <ListItemButton sx={subItemSx(isActive)} disableRipple>
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: 1.1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {renderIcon(Icon, isActive, 16)}
        </ListItemIcon>
        <ListItemText
          primary={toTitleCase(label)}
          primaryTypographyProps={{
            sx: {
              fontSize: "0.8rem",
              fontWeight: isActive ? 600 : 400,
            },
          }}
          sx={{ my: 0 }}
        />
      </ListItemButton>
    </NavLink>
  );

  return (
    <div
      className={`Sidebar_Container ${isMenuExpended && "Sidebar_Effect"}`}
      onMouseOver={() => setOpenOnHover(true)}
      onMouseLeave={() => setOpenOnHover(false)}
    >
      <Box
        className={`${openOnHover && !isMenuExpended ? "Sidebar_H shadow" : ""}`}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: COLORS.bg,
          color: COLORS.textPrimary,
          borderRight: `1px solid ${COLORS.border}`,
          overflowX: "hidden",
        }}
      >
        {openOnHover && (
          <IconButton
            onClick={toggle}
            size="small"
            sx={{
              position: "absolute",
              right: 6,
              top: 10,
              zIndex: 5,
              color: COLORS.accent,
              background: COLORS.accentSoft,
              border: `1px solid ${COLORS.border}`,
              "&:hover": { background: COLORS.accentSoftHover },
              transition: "transform 0.3s ease",
              transform: isMenuExpended ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <ChevronRight size={16} />
          </IconButton>
        )}

        <Box sx={{ p: 1.5 }}>
          {/* Logo */}
          <Box sx={{ mb: 1.5 }}>
            <NavLink
              className="link d-flex flex-row align-items-center justify-content-center"
              to="/DcmTimeTable"
              style={{ textDecoration: "none" }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: expanded ? "flex-start" : "center",
                  width: "100%",
                  gap: 1.25,
                }}
              >
                <img
                  src="/AppLogo.png"
                  className="log_img1"
                  alt="Breathe4 logo"
                  style={{ width: 32, height: 32, objectFit: "contain" }}
                />
                {expanded && (
                  <Typography
                    sx={{
                      color: COLORS.textPrimary,
                      fontWeight: 700,
                      fontSize: "0.95rem",
                      letterSpacing: "0.3px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Breathe4School
                  </Typography>
                )}
              </Box>
            </NavLink>
          </Box>

          <Divider sx={{ borderColor: COLORS.border, mb: 1 }} />

          {/* Scrollable menu list */}
          <List
            className="side-section orange-scrollBar-side"
            sx={{
              p: 0,
              maxHeight: "calc(100vh - 110px)",
              overflowY: "auto",
              overflowX: "hidden",
              "&::-webkit-scrollbar": { width: 6 },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(247,127,0,0.35)",
                borderRadius: 3,
              },
              "&::-webkit-scrollbar-track": { background: "#f1f3f7" },
            }}
          >
            {/* Dashboard */}
            <Box
              onClick={() => {
                dispatch(setActiveMenu(ActiveMenuEnum.DSM));
                navigate("/DcmTimeTable");
                sethwSubMenue(false);
                setEngage(false);
                setStudAttenSubMenue(false);
                setStudAttendance(false);
                setStudPerformance(false);
                setStudPerformanceSubMenue(false);
              }}
            >
              <NavLink
                className="link"
                to="/DcmTimeTable"
                style={{ textDecoration: "none" }}
              >
                {renderMenuItem({
                  label: "Dashboard",
                  Icon: LayoutDashboard,
                  isActive: activeMenu === ActiveMenuEnum.DSM,
                  onClick: () => {
                    dispatch(setActiveMenu(ActiveMenuEnum.DSM));
                    localStorage.setItem("Header", "Digital Class Management");
                    localStorage.setItem("from", "");
                    setEngage(false);
                    sethwSubMenue(false);
                    setStudAttenSubMenue(false);
                    setStudAttendance(false);
                    setStudPerformance(false);
                    setStudPerformanceSubMenue(false);
                  },
                })}
              </NavLink>
            </Box>

            {/* Lecture Management */}
            {hasFeature("TTBL_MGT") && (
              <Box
                onClick={() => {
                  dispatch(setActiveMenu(ActiveMenuEnum.LM));
                  navigate("/lactureManagement");
                  sethwSubMenue(false);
                  setEngage(false);
                  setStudAttenSubMenue(false);
                  setStudAttendance(false);
                  setStudPerformance(false);
                  setStudPerformanceSubMenue(false);
                }}
              >
                <NavLink
                  className="link"
                  to="/lactureManagement"
                  style={{ textDecoration: "none" }}
                  onClick={() => dispatch(setActiveMenu(ActiveMenuEnum.LM))}
                >
                  {renderMenuItem({
                    label: "Lecture Management",
                    Icon: Presentation,
                    isActive: activeMenu === ActiveMenuEnum.LM,
                    onClick: () => {
                      localStorage.setItem("selectedSectionName", "");
                      localStorage.setItem("selectedStandardName", "");
                      localStorage.setItem("selectedStandardId", "");
                      localStorage.setItem("selectedSectionId", "");
                      localStorage.setItem("selectedSectionNameLibrary", "");
                      localStorage.setItem("selectedStandardNameLibrary", "");
                      localStorage.setItem("selectedStandardIdLibrary", "");
                      localStorage.setItem("selectedSectionIdLibrary", "");
                      localStorage.setItem("selectedDate", "");
                      localStorage.setItem("ActiveBtn", "LiveSession");
                      localStorage.setItem("QBIMP", "{}");
                      setEngage(false);
                      sethwSubMenue(false);
                      setStudAttenSubMenue(false);
                      setStudAttendance(false);
                      setStudPerformance(false);
                      setStudPerformanceSubMenue(false);
                    },
                  })}
                </NavLink>
              </Box>
            )}

            {/* Content Library */}
            {hasFeature("CONT_LIB") && (
              <Box
                onClick={() => {
                  dispatch(setActiveMenu(ActiveMenuEnum.CL));
                  navigate("/contentLibrary");
                  sethwSubMenue(false);
                  setEngage(false);
                  setStudAttenSubMenue(false);
                  setStudAttendance(false);
                  setStudPerformance(false);
                  setStudPerformanceSubMenue(false);
                }}
              >
                <NavLink
                  className="link"
                  to="/contentLibrary"
                  style={{ textDecoration: "none" }}
                  onClick={() => dispatch(setActiveMenu(ActiveMenuEnum.CL))}
                >
                  {renderMenuItem({
                    label: "Content Library",
                    Icon: Library,
                    isActive: activeMenu === ActiveMenuEnum.CL,
                    onClick: () => {
                      localStorage.setItem("selectedSectionName", "");
                      localStorage.setItem("selectedStandardName", "");
                      localStorage.setItem("selectedStandardId", "");
                      localStorage.setItem("selectedSectionId", "");
                      localStorage.setItem("selectedSectionNameLibrary", "");
                      localStorage.setItem("selectedStandardNameLibrary", "");
                      localStorage.setItem("selectedStandardIdLibrary", "");
                      localStorage.setItem("selectedSectionIdLibrary", "");
                      localStorage.setItem("selectedDate", "");
                      localStorage.setItem("ActiveBtn", "LiveSession");
                      localStorage.setItem("QBIMP", "{}");
                      setEngage(false);
                      sethwSubMenue(false);
                      setStudAttenSubMenue(false);
                      setStudAttendance(false);
                      setStudPerformance(false);
                      setStudPerformanceSubMenue(false);
                    },
                  })}
                </NavLink>
              </Box>
            )}

            {/* Question Library */}
            {hasFeature("QUES_LIB") && (
              <Box
                onClick={() => {
                  dispatch(setActiveMenu(ActiveMenuEnum.QL));
                  navigate("/questionLibrary");
                  sethwSubMenue(false);
                  setEngage(false);
                }}
              >
                <NavLink
                  className="link"
                  to="/questionLibrary"
                  style={{ textDecoration: "none" }}
                  onClick={() => {
                    dispatch(setActiveMenu(ActiveMenuEnum.QL));
                    setStudAttenSubMenue(false);
                    setStudAttendance(false);
                    setStudPerformance(false);
                    setStudPerformanceSubMenue(false);
                  }}
                >
                  {renderMenuItem({
                    label: "Question Library",
                    Icon: FileQuestion,
                    isActive: activeMenu === ActiveMenuEnum.QL,
                    onClick: () => {
                      localStorage.setItem("selectedSectionName", "");
                      localStorage.setItem("selectedStandardName", "");
                      localStorage.setItem("selectedStandardId", "");
                      localStorage.setItem("selectedSectionId", "");
                      localStorage.setItem("selectedSectionNameLibrary", "");
                      localStorage.setItem("selectedStandardNameLibrary", "");
                      localStorage.setItem("selectedStandardIdLibrary", "");
                      localStorage.setItem("selectedSectionIdLibrary", "");
                      localStorage.setItem("selectedDate", "");
                      localStorage.setItem("ActiveBtn", "LiveSession");
                      localStorage.setItem("QBIMP", "{}");
                      setEngage(false);
                      sethwSubMenue(false);
                      setStudAttenSubMenue(false);
                      setStudAttendance(false);
                      setStudPerformance(false);
                      setStudPerformanceSubMenue(false);
                    },
                  })}
                </NavLink>
              </Box>
            )}

            {/* Assignment */}
            {hasHomework && (
              <>
                {renderMenuItem({
                  label: "Assignment",
                  Icon: ClipboardList,
                  isActive: hwSubMenue || active || HWMactive,
                  onClick: handelExpendHW,
                  showArrow: true,
                  arrowExpanded: hwSubMenue,
                })}

                {hwSubMenue && expanded && (
                  <Collapse in={hwSubMenue} timeout={250} unmountOnExit>
                    <List component="div" disablePadding sx={{ mb: 0.5 }}>
                      {hasHW &&
                        renderSubItem({
                          label: "Homework",
                          Icon: BookOpen,
                          isActive: activeMenu === ActiveMenuEnum.HM,
                          to: "/PublishedHomework",
                          onClick: () => {
                            handleHomeWorkClick();
                            dispatch(setActiveMenu(ActiveMenuEnum.HM));
                            localStorage.setItem(
                              "Header",
                              "Homework Management (Homework)",
                            );
                            localStorage.setItem("clickedHeader", "Homework");
                            localStorage.removeItem("selectedDate");
                            localStorage.removeItem("selectedCheckboxes");
                            localStorage.removeItem("selectedDay");
                            localStorage.setItem("buttons", "Published");
                            setEngage(false);
                            setStudAttenSubMenue(false);
                            setStudAttendance(false);
                            setStudPerformance(false);
                            setStudPerformanceSubMenue(false);
                          },
                        })}

                      {hasPR &&
                        renderSubItem({
                          label: "Pre-Read",
                          Icon: BookMarked,
                          isActive: activeMenu === ActiveMenuEnum.PR,
                          to: "/PublishedHomeworkPreRead",
                          onClick: () => {
                            navigate("/PublishedHomeworkPreRead");
                            localStorage.removeItem("selectedDate");
                            localStorage.removeItem("selectedCheckboxes");
                            localStorage.removeItem("selectedDay");
                            dispatch(setActiveMenu(ActiveMenuEnum.PR));
                            localStorage.setItem(
                              "Header",
                              "Homework Management (Pre-read)",
                            );
                            setEngage(false);
                            setStudPerformance(false);
                            setStudPerformanceSubMenue(false);
                            localStorage.setItem("buttons", "Published");
                          },
                        })}

                      {hasACT &&
                        renderSubItem({
                          label: "Activity",
                          Icon: Activity,
                          isActive: activeMenu === ActiveMenuEnum.ACTIVITY,
                          to: "/PublishedHomeworkActivity",
                          onClick: () => {
                            navigate("/PublishedHomeworkActivity");
                            localStorage.removeItem("selectedDate");
                            localStorage.removeItem("selectedCheckboxes");
                            localStorage.removeItem("selectedDay");
                            dispatch(setActiveMenu(ActiveMenuEnum.ACTIVITY));
                            localStorage.setItem(
                              "Header",
                              "Homework Management (Activity)",
                            );
                            localStorage.setItem("mainButtons", "Created");
                            localStorage.setItem("buttons", "Published");
                            setEngage(false);
                            setStudAttenSubMenue(false);
                            setStudAttendance(false);
                            setStudPerformance(false);
                            setStudPerformanceSubMenue(false);
                          },
                        })}
                    </List>
                  </Collapse>
                )}
              </>
            )}

            {/* Assessment */}
            {hasAssessment && (
              <NavLink
                to="/AddAssessment"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  dispatch(setActiveMenu(ActiveMenuEnum.ASSESSMENT));
                  sethwSubMenue(false);
                  setEngage(false);
                  setStudAttenSubMenue(false);
                  setStudAttendance(false);
                  setStudPerformance(false);
                  setStudPerformanceSubMenue(false);
                }}
              >
                {renderMenuItem({
                  label: "Assessment",
                  Icon: ClipboardCheck,
                  isActive: activeMenu === ActiveMenuEnum.ASSESSMENT,
                  onClick: () => {
                    dispatch(setActiveMenu(ActiveMenuEnum.ASSESSMENT));
                    localStorage.setItem("Header", "Assessment");
                    localStorage.setItem("from", "");
                    localStorage.removeItem("selectedDate");
                    localStorage.removeItem("selectedCheckboxes");
                    localStorage.removeItem("selectedDay");
                    localStorage.setItem("ActiveBtn", "Assessment");
                    setEngage(false);
                    sethwSubMenue(false);
                    setStudAttenSubMenue(false);
                    setStudAttendance(false);
                    setStudPerformance(false);
                    setStudPerformanceSubMenue(false);
                  },
                })}
              </NavLink>
            )}

            {/* Engagement */}
            {hasEngagement && (
              <>
                {renderMenuItem({
                  label: "Engagement",
                  Icon: MessagesSquare,
                  isActive: engage,
                  onClick: handelExpendBtn,
                  showArrow: true,
                  arrowExpanded: subItem,
                })}

                {subItem && expanded && (
                  <Collapse in={subItem} timeout={250} unmountOnExit>
                    <List component="div" disablePadding sx={{ mb: 0.5 }}>
                      {hasFeature("COMMUNITY") &&
                        renderSubItem({
                          label: "Community",
                          Icon: UsersRound,
                          isActive: activeMenu === ActiveMenuEnum.COMMUNITY,
                          to: "/CreateCommunity",
                          onClick: () => {
                            dispatch(setActiveMenu(ActiveMenuEnum.COMMUNITY));
                            localStorage.setItem("Header", "Community");
                          },
                        })}

                      {hasFeature("DOUBT_SOLV") &&
                        renderSubItem({
                          label: "Student Query",
                          Icon: MessageCircleQuestion,
                          isActive: activeMenu === ActiveMenuEnum.STUDENT_QUERY,
                          to: "/queryGroups",
                          onClick: () => {
                            dispatch(
                              setActiveMenu(ActiveMenuEnum.STUDENT_QUERY),
                            );
                            localStorage.setItem("Header", "Students Query");
                          },
                        })}
                    </List>
                  </Collapse>
                )}
              </>
            )}

            {/* Performance & Analytics */}
            {hasPerformance && (
              <>
                {renderMenuItem({
                  label: "Performance & Analytics",
                  Icon: ChartSpline,
                  isActive: studPerformance,
                  onClick: () => handelExpendBtnPerformance(),
                  showArrow: true,
                  arrowExpanded: studPerformance,
                })}

                {studPerformanceSubMenue && expanded && (
                  <Collapse
                    in={studPerformanceSubMenue}
                    timeout={250}
                    unmountOnExit
                  >
                    <List component="div" disablePadding sx={{ mb: 0.5 }}>
                      {hasFeature("OFFL_PERF") && (
                        <>
                          <ListItemButton
                            sx={subItemSx(false)}
                            onClick={handleOfflineMarks}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 0,
                                mr: 1.1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {renderIcon(Pencil, false, 16)}
                            </ListItemIcon>
                            <ListItemText
                              primary="Manage Offline Marks"
                              primaryTypographyProps={{
                                sx: { fontSize: "0.8rem", fontWeight: 400 },
                              }}
                              sx={{ my: 0 }}
                            />
                            <ChevronDown
                              size={14}
                              color={COLORS.textMuted}
                              style={{
                                transition: "transform 0.25s ease",
                                transform: offlineMarksSubMenu
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                              }}
                            />
                          </ListItemButton>

                          <Collapse
                            in={offlineMarksSubMenu}
                            timeout={200}
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {renderSubItem({
                                label: "Academic",
                                Icon: GraduationCap,
                                isActive:
                                  activeMenu === ActiveMenuEnum.ACADEMIC_MARKS,
                                to: "/offline-performance/academic",
                                onClick: () => {
                                  dispatch(
                                    setActiveMenu(
                                      ActiveMenuEnum.ACADEMIC_MARKS,
                                    ),
                                  );
                                  localStorage.setItem(
                                    "Header",
                                    "Academic Marks",
                                  );
                                },
                              })}

                              {renderSubItem({
                                label: "Competency",
                                Icon: Award,
                                isActive:
                                  activeMenu ===
                                  ActiveMenuEnum.COMPETENCY_MARKS,
                                to: "/offline-performance/competency",
                                onClick: () => {
                                  dispatch(
                                    setActiveMenu(
                                      ActiveMenuEnum.COMPETENCY_MARKS,
                                    ),
                                  );
                                  localStorage.setItem(
                                    "Header",
                                    "Competency Marks",
                                  );
                                },
                              })}
                            </List>
                          </Collapse>
                        </>
                      )}

                      {hasFeature("PERFORMANCE_REPORT") &&
                        renderSubItem({
                          label: "Report Card",
                          Icon: FileBarChart,
                          isActive: activeMenu === ActiveMenuEnum.REPORT_CARD,
                          to: "/offlineperformancereport",
                          onClick: () => {
                            dispatch(setActiveMenu(ActiveMenuEnum.REPORT_CARD));
                            localStorage.setItem("Header", "Report Card");
                            setOfflineMarksSubMenu(false);
                          },
                        })}

                      {hasFeature("OL_PERF") &&
                        renderSubItem({
                          label: "Student Analytics",
                          Icon: TrendingUp,
                          isActive: activeMenu === ActiveMenuEnum.SP,
                          to: "/student-performance",
                          onClick: () => {
                            dispatch(setActiveMenu(ActiveMenuEnum.SP));
                            localStorage.setItem("Header", "Student Analytics");
                            setOfflineMarksSubMenu(false);
                          },
                        })}
                    </List>
                  </Collapse>
                )}
              </>
            )}

            {/* Student Attendance */}
            {hasFeature("STUD_ATT") && (
              <>
                {renderMenuItem({
                  label: "Student Attendance",
                  Icon: UserCheck,
                  isActive: studAttendance,
                  onClick: handelExpendBtnStudAttendance,
                  showArrow: true,
                  arrowExpanded: studAttenSubMenue,
                })}

                {studAttenSubMenue && expanded && (
                  <Collapse in={studAttenSubMenue} timeout={250} unmountOnExit>
                    <List component="div" disablePadding sx={{ mb: 0.5 }}>
                      {renderSubItem({
                        label: "Mark Attendance",
                        Icon: CalendarCheck,
                        isActive: activeMenu === ActiveMenuEnum.MARK_ATTENDANCE,
                        to: "/markattendance",
                        onClick: () => {
                          dispatch(
                            setActiveMenu(ActiveMenuEnum.MARK_ATTENDANCE),
                          );
                          localStorage.setItem("Header", "Mark Attendance");
                        },
                      })}

                      {renderSubItem({
                        label: "Notify Shortage",
                        Icon: BellRing,
                        isActive: activeMenu === ActiveMenuEnum.NOTIFY_SHORTAGE,
                        to: "/notifyshortage",
                        onClick: () => {
                          dispatch(
                            setActiveMenu(ActiveMenuEnum.NOTIFY_SHORTAGE),
                          );
                          localStorage.setItem("Header", "Notify Shortage");
                        },
                      })}

                      {renderSubItem({
                        label: "Report",
                        Icon: FileText,
                        isActive: activeMenu === ActiveMenuEnum.REPORT,
                        to: "/attendancereport",
                        onClick: () => {
                          dispatch(setActiveMenu(ActiveMenuEnum.REPORT));
                          localStorage.setItem("Header", "Report");
                        },
                      })}

                      {renderSubItem({
                        label: "Leave Management",
                        Icon: CalendarClock,
                        isActive: activeMenu === ActiveMenuEnum.LEVM,
                        to: "/leavemanagement",
                        onClick: () => {
                          dispatch(setActiveMenu(ActiveMenuEnum.LEVM));
                          localStorage.setItem("Header", "Leave Management");
                        },
                      })}
                    </List>
                  </Collapse>
                )}
              </>
            )}

            {/* Teacher Attendance & Leave */}
            {hasFeature("TEACH_ATT") && (
              <>
                {renderMenuItem({
                  label: "Teacher Attendance & Leave",
                  Icon: GraduationCap,
                  isActive: teaHr,
                  onClick: handelExpendTeaHr,
                  showArrow: true,
                  arrowExpanded: teaHrSubMenue,
                })}

                {teaHrSubMenue && expanded && (
                  <Collapse in={teaHrSubMenue} timeout={250} unmountOnExit>
                    <List component="div" disablePadding sx={{ mb: 0.5 }}>
                      {renderSubItem({
                        label: "My Attendance — Today",
                        Icon: CalendarCheck,
                        isActive: activeMenu === ActiveMenuEnum.TEA_ATT_TODAY,
                        to: "/tea-attendance-today",
                        onClick: () => {
                          dispatch(setActiveMenu(ActiveMenuEnum.TEA_ATT_TODAY));
                          localStorage.setItem(
                            "Header",
                            ActiveMenuEnum.TEA_ATT_TODAY,
                          );
                        },
                      })}

                      {renderSubItem({
                        label: "Attendance History",
                        Icon: CalendarClock,
                        isActive: activeMenu === ActiveMenuEnum.TEA_ATT_HISTORY,
                        to: "/tea-attendance-history",
                        onClick: () => {
                          dispatch(
                            setActiveMenu(ActiveMenuEnum.TEA_ATT_HISTORY),
                          );
                          localStorage.setItem(
                            "Header",
                            ActiveMenuEnum.TEA_ATT_HISTORY,
                          );
                        },
                      })}

                      {renderSubItem({
                        label: "Attendance Report",
                        Icon: ClipboardCheck,
                        isActive: activeMenu === ActiveMenuEnum.TEA_ATT_REPORT,
                        to: "/tea-attendance-report",
                        onClick: () => {
                          dispatch(
                            setActiveMenu(ActiveMenuEnum.TEA_ATT_REPORT),
                          );
                          localStorage.setItem(
                            "Header",
                            ActiveMenuEnum.TEA_ATT_REPORT,
                          );
                        },
                      })}

                      {renderSubItem({
                        label: "Apply For Leave",
                        Icon: Send,
                        isActive: activeMenu === ActiveMenuEnum.TEA_LEAVE_APPLY,
                        to: "/tea-leave-apply",
                        onClick: () => {
                          dispatch(
                            setActiveMenu(ActiveMenuEnum.TEA_LEAVE_APPLY),
                          );
                          localStorage.setItem(
                            "Header",
                            ActiveMenuEnum.TEA_LEAVE_APPLY,
                          );
                        },
                      })}

                      {renderSubItem({
                        label: "My Leave Requests",
                        Icon: ListChecks,
                        isActive: activeMenu === ActiveMenuEnum.TEA_LEAVE_LIST,
                        to: "/tea-leave-requests",
                        onClick: () => {
                          dispatch(
                            setActiveMenu(ActiveMenuEnum.TEA_LEAVE_LIST),
                          );
                          localStorage.setItem(
                            "Header",
                            ActiveMenuEnum.TEA_LEAVE_LIST,
                          );
                        },
                      })}

                      {renderSubItem({
                        label: "Leave Balances",
                        Icon: Scale,
                        isActive:
                          activeMenu === ActiveMenuEnum.TEA_LEAVE_BALANCES,
                        to: "/tea-leave-balances",
                        onClick: () => {
                          dispatch(
                            setActiveMenu(ActiveMenuEnum.TEA_LEAVE_BALANCES),
                          );
                          localStorage.setItem(
                            "Header",
                            ActiveMenuEnum.TEA_LEAVE_BALANCES,
                          );
                        },
                      })}
                    </List>
                  </Collapse>
                )}
              </>
            )}

            {/* Salary / Payslips */}
            {hasFeature("SALARY_MGT") && (
              <Box
                onClick={() => {
                  dispatch(setActiveMenu(ActiveMenuEnum.SALARY_PAYSLIPS));
                  navigate("/tea-payslips");
                  sethwSubMenue(false);
                  setEngage(false);
                  setStudAttenSubMenue(false);
                  setStudAttendance(false);
                  setStudPerformance(false);
                  setStudPerformanceSubMenue(false);
                  setTeaHr(false);
                  setTeaHrSubMenue(false);
                }}
              >
                <NavLink
                  className="link"
                  to="/tea-payslips"
                  style={{ textDecoration: "none" }}
                  onClick={() => {
                    dispatch(setActiveMenu(ActiveMenuEnum.SALARY_PAYSLIPS));
                    localStorage.setItem(
                      "Header",
                      ActiveMenuEnum.SALARY_PAYSLIPS,
                    );
                  }}
                >
                  {renderMenuItem({
                    label: ActiveMenuEnum.SALARY_PAYSLIPS,
                    Icon: Wallet,
                    isActive: activeMenu === ActiveMenuEnum.SALARY_PAYSLIPS,
                  })}
                </NavLink>
              </Box>
            )}

            {/* My Students */}
            <Box
              onClick={() => {
                dispatch(setActiveMenu(ActiveMenuEnum.MS));
                navigate("/my-students");
                sethwSubMenue(false);
                setEngage(false);
                setStudAttenSubMenue(false);
                setStudAttendance(false);
                setStudPerformance(false);
                setStudPerformanceSubMenue(false);
                setTeaHr(false);
                setTeaHrSubMenue(false);
              }}
            >
              <NavLink
                className="link"
                to="/my-students"
                style={{ textDecoration: "none" }}
                onClick={() => dispatch(setActiveMenu(ActiveMenuEnum.MS))}
              >
                {renderMenuItem({
                  label: "My Students",
                  Icon: Users,
                  isActive: activeMenu === ActiveMenuEnum.MS,
                  onClick: () => {
                    localStorage.setItem("selectedSectionName", "");
                    localStorage.setItem("selectedStandardName", "");
                    localStorage.setItem("selectedStandardId", "");
                    localStorage.setItem("selectedSectionId", "");
                    localStorage.setItem("selectedSectionNameLibrary", "");
                    localStorage.setItem("selectedStandardNameLibrary", "");
                    localStorage.setItem("selectedStandardIdLibrary", "");
                    localStorage.setItem("selectedSectionIdLibrary", "");
                    localStorage.setItem("selectedDate", "");
                    localStorage.setItem("ActiveBtn", "LiveSession");
                    localStorage.setItem("QBIMP", "{}");
                    setEngage(false);
                    sethwSubMenue(false);
                    setStudAttenSubMenue(false);
                    setStudAttendance(false);
                    setStudPerformance(false);
                    setStudPerformanceSubMenue(false);
                  },
                })}
              </NavLink>
            </Box>
            {/* --- OSM SECTION START --- */}
            {hasFeature("OSM_MARK") && (
              <>
                <Box sx={{ mt: 2, mb: 1 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      pl: 2,
                      color: COLORS.textMuted,
                      fontWeight: 700,
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      fontSize: "0.65rem",
                      display: expanded ? "block" : "none",
                    }}
                  >
                    Marking Tools
                  </Typography>
                </Box>

                <Box
                  onClick={() => {
                    dispatch(setActiveMenu(ActiveMenuEnum.OSM_LIST));
                    navigate("/osm");
                    sethwSubMenue(false);
                    setEngage(false);
                    setStudAttenSubMenue(false);
                    setStudAttendance(false);
                    setStudPerformance(false);
                    setStudPerformanceSubMenue(false);
                    setTeaHr(false);
                    setTeaHrSubMenue(false);
                  }}
                >
                  <NavLink
                    className="link"
                    to="/osm"
                    style={{ textDecoration: "none" }}
                    onClick={() =>
                      dispatch(setActiveMenu(ActiveMenuEnum.OSM_LIST))
                    }
                  >
                    {renderMenuItem({
                      label: "Online Script Marking",
                      Icon: MonitorPlay,
                      isActive: activeMenu === ActiveMenuEnum.OSM_LIST,
                      onClick: () => {
                        localStorage.setItem("Header", "OSM Scripts");
                      },
                    })}
                  </NavLink>
                </Box>
              </>
            )}
            {/* --- OSM SECTION END --- */}
          </List>
        </Box>
      </Box>
    </div>
  );
}

export default Sidebar;
